import { BaseApiResponse } from '../../../../../api/shared'
import { ThisConnector } from '../../../../../api/connector'

export interface DeleteConfigurationArgs {
  organizationUuid: string
  configurationId?: number
}

export function deleteConfiguration(
  this: ThisConnector,
  { organizationUuid, configurationId }: DeleteConfigurationArgs
): Promise<BaseApiResponse> {
  return this.connector.executeDelete<BaseApiResponse>(
    `/${organizationUuid}/bugtrackers/${configurationId}?expand=skip_links`
  )
}
